import { useMemo, useState } from 'react'
import Swal from 'sweetalert2'
import WojewodztwoService from '@/services/WojewodztwoService'

export default function useWojewodztwaModal(loadData) {
	const [isModalOpen, setIsModalOpen] = useState(false)
	const [editingItem, setEditingItem] = useState(null)
	const [formName, setFormName] = useState('')
	const [isSaving, setIsSaving] = useState(false)

	const openCreateModal = () => {
		setEditingItem(null)
		setFormName('')
		setIsModalOpen(true)
	}

	const openEditModal = item => {
		setEditingItem(item)
		setFormName(item?.nazwa || '')
		setIsModalOpen(true)
	}

	const closeModal = () => {
		setIsModalOpen(false)
		setEditingItem(null)
		setFormName('')
		setIsSaving(false)
	}

	const handleSubmit = async e => {
		e.preventDefault()
		const name = formName.trim()
		if (!name) return

		setIsSaving(true)
		const result = editingItem?._id
			? await WojewodztwoService.update(editingItem._id, { nazwa: name })
			: await WojewodztwoService.create({ nazwa: name })

		if (!result?.success) {
			Swal.fire({
				title: 'Error',
				text: result?.error || 'Nie udalo sie zapisac wojewodztwa',
				icon: 'error',
			})
			setIsSaving(false)
			return
		}

		const wasEditing = !!editingItem
		closeModal()
		await loadData()
	}

	const handleDelete = async item => {
		const confirm = await Swal.fire({
			title: 'Czy na pewno?',
			text: `Usunac wojewodztwo "${item?.nazwa || '-'}"?`,
			icon: 'warning',
			showCancelButton: true,
			confirmButtonText: 'Tak, usun',
			cancelButtonText: 'Anuluj',
		})
		if (!confirm.isConfirmed) return

		const result = await WojewodztwoService.delete(item?._id)
		if (!result?.success) {
			Swal.fire({
				title: 'Error',
				text: result?.error || 'Nie udalo sie usunac wojewodztwa',
				icon: 'error',
			})
			return
		}

		await loadData()
		Swal.fire({
			title: 'Usunieto',
			text: 'Wojewodztwo zostalo usuniete',
			icon: 'success',
		})
	}

	const buttons = useMemo(
		() => [
			{
				type: 'add',
				label: 'Dodaj nowe',
				onClick: openCreateModal,
			},
		],
		[]
	)

	return {
		isModalOpen,
		editingItem,
		formName,
		setFormName,
		isSaving,
		openEditModal,
		handleDelete,
		closeModal,
		handleSubmit,
		buttons,
	}
}
